var _defs, _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _g8, _path2, _g9, _path3, _g10, _path4, _path5, _image, _text, _g11, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "No_registers",
    "data-name": "No registers",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1371.02 1369.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1f6c8e;}.cls-2{fill:#2baae2;}.cls-3{fill:#96d9f2;}.cls-4{fill:#dbe5e4;}.cls-4,.cls-5,.cls-6{stroke:#fff;}.cls-4,.cls-5,.cls-6,.cls-9{stroke-miterlimit:10;}.cls-16,.cls-5{fill:#fff;}.cls-6{fill:#f4f4f4;}.cls-7{fill:url(#linear-gradient);}.cls-8{font-size:88.41px;}.cls-10,.cls-8{fill:#3ea4dc;}.cls-17,.cls-8{font-family:ArialRoundedMTBold, Arial Rounded MT Bold;}.cls-9{fill:none;stroke:#4093c2;stroke-width:2px;}.cls-11{fill:#2e79a4;}.cls-12{fill:#4594c2;}.cls-13{fill:#144d66;}.cls-14{fill:#efb192;}.cls-15{fill:#f1c3ad;}.cls-17{font-size:125.37px;fill:#e4f0fa;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3806.81,
    y1: 5484.42,
    x2: 3869.84,
    y2: 5484.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 5372.17, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9dc8eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96d9f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Magnifying"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 910.74,
    cy: 1221.79,
    rx: 460.28,
    ry: 147.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 749.83,
    y: 6238.38,
    width: 474.67,
    height: 45.88,
    rx: 9.81,
    transform: "translate(1224.5 7492.72) rotate(180)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bg-Circles"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1060.23,
    cy: 5456.7,
    r: 197.24,
    transform: "translate(-4297.76 -2682) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 985.79,
    cy: 216.86,
    r: 194.61
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Suit"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1321.66,5535.61l108.72-121.32a126.05,126.05,0,0,1,38.8-24.41,124.17,124.17,0,0,1,40.77-8.66,333.78,333.78,0,0,1,122.15-4.14,319.1,319.1,0,0,1,45.12,10.24c34,10.48,129.73,40,163.43,125.34,5.65,14.32,26.77,67.82,0,122.79-28.14,57.77-87.48,72.6-96.3,74.65l-64-82.2c25.46-1.71,46.21-22,49-47.7,2.75-25.43-12.76-49.59-36.83-57.23q-6.09,52.47-12.17,104.93H1472.69V5503L1409,5572.52c-24.76,20.07-56.53,19.67-73.69,3.07C1320.64,5561.38,1321.42,5539.92,1321.66,5535.61Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1571.06,6081.75l142-10.61-32.31-450.35L1474,5610.53Q1522.51,5846.15,1571.06,6081.75Z",
    transform: "translate(-749.83 -5029.92)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Docs2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "439.52 661.33 292.51 619.95 329.32 406.87 476.33 448.25 439.52 661.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "465.32 356.55 360.88 377.95 327.88 225.96 432.31 204.56 465.32 356.55"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Docs1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "221.87 630.08 416.42 610.1 393.94 325.28 199.39 345.26 221.87 630.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "510.54 479.34 662.25 380.63 548.31 153.38 396.6 252.09 510.54 479.34"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pocket",
    className: "cls-7",
    d: "M1502.33,5503a38.7,38.7,0,0,0,30.33,15.89c13.48.38,26.17-5.79,32.7-15.89v-53.05h-63Z",
    transform: "translate(-749.83 -5029.92)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1909.21,5115.41c-1.22,44.18-64.27,79-116.14,76.77-60.41-2.61-111.18-55.72-108.6-84.55a44,44,0,0,1,11.75-26.46c2.4-2.26,9.13-8.61,17.61-8.08,8.2.51,12.5,7.13,15,5.39,2.88-2-3.65-10.7-1.76-21.56,2.37-13.6,16.23-20.87,17.61-21.57,1-.51,16.7-8.18,28.17-.89,8.17,5.18,9.59,15,13.2,14.37,3.14-.57,1.89-7.95,7-13.48s13.49-5.53,21.13-5.39a72.61,72.61,0,0,1,29.93,7.19C1848.18,5039.16,1910.44,5070.85,1909.21,5115.41Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 961.73,
    cy: 179.24,
    rx: 27.19,
    ry: 27.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 922.39,
    cy: 223.49,
    rx: 15.74,
    ry: 16.07
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Question-Sign"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "matrix(0.23, -0.12, 0.49, 0.87, 533.34, 336.16)"
  }, "?"), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1271.23,
    cy: 5336.43,
    rx: 38.93,
    ry: 54.73,
    transform: "translate(-2516.05 -4261.58) rotate(-20.22)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Doc-Face"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "249.31 409.51 350.81 396.81 350.08 390.71 248.58 403.42 249.31 409.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "264.63 429.47 335.57 420.59 334.84 414.5 263.9 423.37 264.63 429.47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 272.32,
    cy: 469.84,
    rx: 8.83,
    ry: 9.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 343.3,
    cy: 467.01,
    rx: 7.93,
    ry: 8.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1070.48,5562.52a25.52,25.52,0,0,0-31.26-.69l-.06,3.1a26.39,26.39,0,0,1,15.13-4.54c14.24.36,22.29,13,23,14.22Z",
    transform: "translate(-749.83 -5029.92)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Hair2",
    className: "cls-13",
    d: "M1573.14,5303.08c-2.81,7-7.75,22.25-2.83,38.67,4.74,15.8,16.45,24.85,25,31,43.17,30.81,70.48,33.18,94.17,50.45,16.88,12.3,36.85,35.75,46.56,85.05,4.68-3.31,31.72-23.13,37-59.32A85.55,85.55,0,0,0,1765,5399c-3.85-11.7-10.88-27.79-24.52-42.33-16.51-17.6-34.51-24.19-45.44-29-22.24-9.68-52.23-27.86-84.7-65.31a96.11,96.11,0,0,0-17.51,13.53A98.81,98.81,0,0,0,1573.14,5303.08Z",
    transform: "translate(-749.83 -5029.92)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Skin"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1511.31,
    cy: 5292.48,
    rx: 15.38,
    ry: 7.36,
    transform: "translate(-4713 832.15) rotate(-80)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1679.41,5744.18h0a9.26,9.26,0,0,0-5.11,11.93l12.27,31.9a9,9,0,0,0,11.7,5.21h0a9.27,9.27,0,0,0,5.1-11.94l-12.27-31.9A9,9,0,0,0,1679.41,5744.18Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 721.77,
    cy: 361.96,
    rx: 41.08,
    ry: 41.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1481.57,5348.35l-1.79,3.5a9.3,9.3,0,0,0,3.82,12.43l44.71,23.82a8.93,8.93,0,0,0,12.17-3.9l1.79-3.5a9.29,9.29,0,0,0-3.82-12.42l-44.7-23.83A9,9,0,0,0,1481.57,5348.35Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1488.59,5409.91l3.7,2.84a8.9,8.9,0,0,0,12.63-1.82l30.33-41.12a9.34,9.34,0,0,0-1.79-12.9l-3.69-2.84a8.91,8.91,0,0,0-12.64,1.82L1486.8,5397A9.34,9.34,0,0,0,1488.59,5409.91Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1468.46,5369.81l3.69,1.16a9,9,0,0,0,11.28-6.1l2.94-9.76a9.24,9.24,0,0,0-6-11.51l-3.69-1.16a9,9,0,0,0-11.28,6.1l-3,9.76A9.25,9.25,0,0,0,1468.46,5369.81Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1448.15,5370.55l3.7,1.16a9,9,0,0,0,11.28-6.09l2.94-9.76a9.24,9.24,0,0,0-6-11.51l-3.7-1.16a9,9,0,0,0-11.28,6.09l-2.94,9.76A9.24,9.24,0,0,0,1448.15,5370.55Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1713.61,5686.36c-10.94-9.89-40.41-2.17-49.83,18.4-8.57,18.73.91,43.06,18,50.85,13.1,6,31.44,2.59,36.85-7.22,3.4-6.15-.8-10.3-2.75-28.87C1713.58,5697.24,1718.59,5690.87,1713.61,5686.36Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1680.46,5747.79l-1.48,1.28a9.33,9.33,0,0,0-1,13l28.71,34.57a8.91,8.91,0,0,0,12.72,1.07l1.48-1.28a9.34,9.34,0,0,0,1.05-13l-28.72-34.57A8.9,8.9,0,0,0,1680.46,5747.79Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1702,5746.55l-1.35,1.42a9.34,9.34,0,0,0,.16,13l14,13.89a8.9,8.9,0,0,0,12.76-.17l1.35-1.42a9.34,9.34,0,0,0-.16-13l-14-13.88A8.9,8.9,0,0,0,1702,5746.55Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1707.78,5734.49l-1.35,1.41a9.35,9.35,0,0,0,.16,13l5.4,5.37a8.9,8.9,0,0,0,12.76-.17l1.35-1.42a9.34,9.34,0,0,0-.16-13l-5.4-5.37A8.89,8.89,0,0,0,1707.78,5734.49Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1680.11,5742.7h0a9.28,9.28,0,0,0-5.11,11.94l12.27,31.9a9,9,0,0,0,11.7,5.21h0a9.28,9.28,0,0,0,5.1-11.94l-12.27-31.9A9,9,0,0,0,1680.11,5742.7Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1507.37,5322.17c.45,3.88,1.08,9.44,3.91,15,9.83,19.46,37.38,22.24,40.84,22.54,26.63,2.31,57.21-13.27,61.85-33.62,1.51-6.63-1.42-6.27-2.43-30.87-.67-16.5.49-20.05-2.43-27-4-9.6-11.26-14.92-18.5-20.23-9-6.61-17.66-12.95-30.39-13.49-13-.55-27.12,5.13-35.67,16.19-3.88,5-5.65,10.75-7.93,17.53-1.38,4.09-1.91,6.56-4.45,19.33C1507.28,5312.16,1506.67,5316,1507.37,5322.17Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1617.97,
    cy: 5304.06,
    rx: 7.36,
    ry: 15.39,
    transform: "translate(-1373.76 -4797.82) rotate(-6.88)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-13",
    d: "M1516.27,5264.32a151.69,151.69,0,0,0,19.08-3.85c16.59-4.46,19.59-8.26,26.16-6.75,9.16,2.11,10,11,21,21.08,8.57,7.83,18.64,12.05,28.43,14.29a23.22,23.22,0,0,0,5.66-16.34,22.4,22.4,0,0,0-4-11.26c-2.68-4.61-16.14-26.78-40.11-30.79-12.8-2.15-24.76,1.53-30.25,3.22a82.55,82.55,0,0,0-22.89,11.2Z",
    transform: "translate(-749.83 -5029.92)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Glass"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 910.14,
    cy: 1208.46,
    rx: 433.37,
    ry: 142.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1605.97,
    y: 6189.8,
    width: 322.36,
    height: 45.88,
    rx: 9.81,
    transform: "translate(81.29 7573.81) rotate(-155.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1454.86,
    y: 6202.23,
    width: 322.36,
    height: 46.82,
    rx: 9.81,
    transform: "translate(-847.08 7395.29) rotate(-150)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Right-Shoe",
    className: "cls-13",
    d: "M1681.21,6102.48a219,219,0,0,1-19.12-20.93l50.3-80.86,72.92,42-.54.87,30.51,18.63-87.51,140.69a75.89,75.89,0,0,1-11.18-17.89,64.31,64.31,0,0,1-5.6-24.87q3.27-14.44,7-29.13a.29.29,0,0,0,0-.09A215.83,215.83,0,0,1,1681.21,6102.48Z",
    transform: "translate(-749.83 -5029.92)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Left-Shoe",
    className: "cls-13",
    d: "M1521.8,6213.27a75.28,75.28,0,0,1,8.81-19.14,62.12,62.12,0,0,1,17.62-18.07q13.74-4.91,27.94-9.54l.09,0a220.75,220.75,0,0,1,3.68-46.71,218.52,218.52,0,0,1,7-27.57h94.25l2.43,45.41h0q1.07,19.77,2.12,39.54h-1q.51,18.06,1,36.11Z",
    transform: "translate(-749.83 -5029.92)"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Logo",
    width: 401,
    height: 182,
    transform: "matrix(-0.15, 0, 0, 0.15, 813.43, 436.79)",
    xlinkHref: "../../../../../../Users/HP/Downloads/logo%20nubeteck%20azul%20recorte.png"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "matrix(0.96, -0.05, 0.06, 1, 1027.05, 128.89)"
  }, "?")), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Left-Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1582.62,5788.93c.76,2,4.64,11.5,14.94,16.08,13.55,6,26.06-1.86,27.1-2.54l13.5-42.94-42-13.55Z",
    transform: "translate(-749.83 -5029.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Left-Leg-2",
    "data-name": "Left-Leg",
    className: "cls-2",
    d: "M1407.67,5815.17c3.69-18.17,8.21-37.35,13.74-57.34,7.52-27.22,15.9-52.24,24.5-74.95q13.65-42.53,27.31-85.05l84.71,121.9a49.56,49.56,0,0,1,12.62,18.86c9.26,25.52-9.74,45.34-10.46,70.4-.81,28.7,25,45.85,44.48,70.71,22.78,29,53.8,73.16,84.21,134.76l-121.1,74.66L1444,5917.85a172.22,172.22,0,0,1-28.41-54.2A174.19,174.19,0,0,1,1407.67,5815.17Z",
    transform: "translate(-749.83 -5029.92)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Left-Arm",
    className: "cls-2",
    d: "M1477.86,5474.24l-64.58-53.6-91.62,115c-.09,1.9-.86,29.82,21.73,46,19,13.6,39.82,8.41,42.85,7.6Z",
    transform: "translate(-749.83 -5029.92)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/NoResults.00dea18dc0dddb10abcc580999e19e11.svg";
export { ForwardRef as ReactComponent };